
import * as THREE from 'three';

export class Line {
    
    constructor(private e: number, private start: THREE.Vector3, private end: THREE.Vector3) {

    }

    // 点が線分上に存在するか
    public overLine(point: THREE.Vector3): boolean {
        const line1 = point.clone().sub(this.start);
        const line2 = this.end.clone().sub(this.start);

        return this.withinHeight(line1.clone().normalize(), line2.clone().normalize()) && this.withinWeight(line1, line2);
    }

    // 高さ e以内
    private withinHeight(line1: THREE.Vector3, line2: THREE.Vector3): boolean {
        // console.log(line1.clone().cross(line2).length());
        
        return (0 <= line1.clone().cross(line2).length() && line1.clone().cross(line2).length() <= this.e);
    }

    // 幅 e以内
    private withinWeight(line1: THREE.Vector3, line2: THREE.Vector3): boolean {
        // console.log(line1.clone().dot(line2));

        const line1_ = line1.clone().normalize();
        const line2_ = line2.clone().normalize();
        const cos = line1_.clone().dot(line2_);
        return ((-this.e <= cos && cos <= 1 + this.e) && (line1.length() * cos <= line2.length() * cos + this.e));
    }

    // 距離
    public setDistance(distance: number) {
        this.e = distance;
    }

}